import React, { useState, useEffect } from 'react';
import TimelinePic from '../Images/updatedtimeline.png';
import TimelineMobilePic from '../Images/updatedtimeline.png'; // double-check name
import '../styles/Timeline.css';

function Timeline() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia('(max-width: 768px)');
    setIsMobile(mediaQuery.matches);

    const handleResize = (e) => setIsMobile(e.matches);
    mediaQuery.addEventListener('change', handleResize);

    return () => mediaQuery.removeEventListener('change', handleResize);
  }, []);

  return (
    <div className="timeline-wrapper">
      <img
        src={isMobile ? TimelineMobilePic : TimelinePic}
        alt="Responsive Timeline"
        className={`responsive-image-time ${isMobile ? 'mobile-image' : 'desktop-image'}`}
      />
    </div>
  );
}

export default Timeline;
